{
  "signIn": {
    "title": "Sign in",
    "subtitle": "Welcome back. Sign in to manage your devices and messages.",
    "email": "Email",
    "password": "Password",
    "forgot": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "or": "or",
    "noAccount": "No account yet?",
    "register": "Create an account",
    "invalidCredentials": "The email or password is incorrect. After five wrong attempts, the account is locked for 15 minutes.",
    "rateLimited": "Too many attempts. You can try again in {{time}}.",
    "rateLimitedLead": "Too many attempts. You can try again in",
    "rateLimitedNoTime": "Too many attempts. Wait a few minutes before trying again.",
    "googleUnavailable": "Google sign-in could not be loaded. Use your email and password."
  },
  "notice": {
    "reused": "This session was used from somewhere else and was closed. Sign in again.",
    "expired": "Your session has ended. Sign in again.",
    "banned": "This account is disabled. Contact support if you think this is a mistake.",
    "challenge": "That verification step expired. Sign in again to get a new one.",
    "reset": "Your password was changed and every session was closed. Sign in with the new password.",
    "idle": "You were signed out after 30 minutes without activity. Sign in again to continue."
  },
  "totp": {
    "title": "Two-step verification",
    "subtitle": "Enter the 6-digit code from your authenticator app.",
    "recoverySubtitle": "Enter one of the recovery codes you saved when you set up two-step verification.",
    "code": "Verification code",
    "recoveryCode": "Recovery code",
    "useRecovery": "Use a recovery code instead",
    "useApp": "Use a code from the app instead",
    "submit": "Verify",
    "submitting": "Checking…",
    "back": "Back to sign-in"
  },
  "register": {
    "title": "Create your account",
    "subtitle": "Send SMS through your own Android phones, from one dashboard.",
    "name": "Full name",
    "optional": "optional",
    "email": "Email",
    "password": "Password",
    "passwordHint": "8 to 128 characters.",
    "phone": "Phone",
    "language": "Language of your emails",
    "submit": "Create account",
    "submitting": "Creating…",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in",
    "doneTitle": "Check your email",
    "doneBody": "We sent a confirmation link to {{email}}. Open it to confirm your address, then sign in.",
    "toSignIn": "Go to sign-in"
  },
  "verify": {
    "title": "Confirm your email",
    "checking": "Confirming your address…",
    "doneTitle": "Email confirmed",
    "doneBody": "Thank you. Your address is confirmed.",
    "toDashboard": "Go to the dashboard",
    "toSignIn": "Go to sign-in",
    "invalidTitle": "This link no longer works",
    "missingToken": "This link is incomplete. Open the link from the email again, without changing it.",
    "resend": "Send me a new link",
    "resending": "Sending…",
    "resent": "A new link is on its way. Check your inbox.",
    "signInToResend": "Sign in to ask for a new link."
  },
  "unsubscribe": {
    "title": "Stop these emails?",
    "body": "You will no longer receive this kind of optional email. Security, payment and plan emails still reach you.",
    "confirm": "Stop these emails",
    "confirming": "Saving…",
    "doneTitle": "You are unsubscribed",
    "done_usageAlerts": "You will no longer receive usage alerts.",
    "done_creditWarnings": "You will no longer receive credit warnings.",
    "manage": "Manage email preferences",
    "invalidTitle": "This link no longer works",
    "missingToken": "This link is incomplete. Open it from the email again, without changing it."
  },
  "forgot": {
    "title": "Reset your password",
    "subtitle": "Enter your account’s email. We will send you a 6-digit code.",
    "email": "Email",
    "submit": "Send the code",
    "submitting": "Sending…",
    "sentTitle": "Check your email",
    "sentBody": "If an account exists for {{email}}, a 6-digit code is on its way. It expires after a short while.",
    "enterCode": "Enter the code",
    "back": "Back to sign-in"
  },
  "reset": {
    "title": "Choose a new password",
    "subtitle": "Enter the 6-digit code we emailed you, then your new password.",
    "email": "Email",
    "otp": "6-digit code",
    "newPassword": "New password",
    "confirm": "Confirm the new password",
    "submit": "Change password",
    "submitting": "Changing…",
    "requestCode": "No code? Ask for a new one",
    "back": "Back to sign-in"
  },
  "invite": {
    "title": "Join the team",
    "subtitle": "Choose your name and password to accept the invitation.",
    "name": "Full name",
    "password": "Password",
    "submit": "Accept and sign in",
    "submitting": "Signing in…",
    "missingToken": "This invitation link is incomplete. Open the link from the email again, without changing it.",
    "toSignIn": "Go to sign-in"
  },
  "enrol": {
    "title": "Set up two-step verification",
    "subtitle": "Staff accounts must confirm each sign-in with an authenticator app. It takes a minute.",
    "passwordIntro": "First, confirm your password.",
    "password": "Password",
    "continue": "Continue",
    "checking": "Checking…",
    "scan": "Scan this QR code with your authenticator app, then enter the 6-digit code it shows.",
    "recoveryTitle": "Save your recovery codes",
    "recoverySubtitle": "Each code signs you in once if you lose your phone.",
    "stepUpExpired": "Your confirmation expired. Enter your password again."
  },
  "validation": {
    "required": "This field is required.",
    "email": "Enter a valid email address.",
    "passwordLength": "Use 8 to 128 characters.",
    "otp": "Enter the 6 digits of the code.",
    "recoveryCode": "Enter the recovery code as it was given to you.",
    "nameLength": "Use 100 characters at most.",
    "phoneLength": "Use 32 characters at most.",
    "mismatch": "The two passwords are different."
  }
}
